import { LastReportsProvider as Provider } from 'hooks/lastReports';

const LastReportsProvider = ({ children }) => (
	<Provider>{children}</Provider>
);

export default LastReportsProvider;
